export default function VMAMasterProductDirectiveController(
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  editMasterProductDialog,
  ssDialogService,
  vmDataService
) {
  const vm = this;
  vm.handleEditClick = handleEditClick;
  vm.handleDeleteClick = handleDeleteClick;
  _activate();

  function _activate() {
    vm.currentSavedName = $scope.vmaMasterProductVM.masterProduct.name;
  }

  function handleEditClick($event) {
    ssDialogService.dialogs.vendorManagement.editMasterProductDialog = ssDialogService.alert(
      editMasterProductDialog.getOptions($event, {
        masterProduct: vm.masterProduct
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.editMasterProductDialog);
  }

  function handleDeleteClick($event) {
    ssDialogService.dialogs.auditTrail.deleteMasterProductConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Master Product?',
        message: `Are you sure you want to delete Master Product "${vm.masterProduct.name}"?`,
        handleYesClick: () => {
          _handleConfirmDeleteClick();
        },

        handleNoClick: () => {
          _handleCancelDeleteClick();
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteMasterProductConfirmDialog);
  }

  function _handleConfirmDeleteClick() {
    vmDataService.deleteMasterProduct(
      vm.masterProduct.masterProductId
    ).then((response) => {
      if (response.status === 200) {
        alerts.success(`The Master Product "${vm.masterProduct.name}" was successfully deleted.`);
        $rootScope.$broadcast('refreshVMAMasterVendor', {
          masterVendorId: vm.masterProduct.masterVendorId
        });
        _closeDeleteDialog();
      } else {
        alerts.error('An error occurred while deleting the Master Product.');
      }
    });
  }

  function _handleCancelDeleteClick() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteMasterProductConfirmDialog);
  }
}

VMAMasterProductDirectiveController.$inject = [
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'editMasterProductDialog',
  'ssDialogService',
  'vmDataService'
];
